import {
  createEditorPlatformManifestServicesError,
  EditorPlatformManifestServicesErrorCode,
} from '../errors';
import { AbstractManifestStore } from './AbstractManifestStore';
import { EditorContextProviderExtensionType } from './types';
import type { EditorElement } from '@wix/component-protocol/schema';

export class ProviderManifestStore extends AbstractManifestStore<EditorContextProviderExtensionType> {
  getProviderVirtualManifestByContextType(contextType: string): EditorElement {
    const contextManifest = this.get(contextType);
    if (!contextManifest) {
      throw createEditorPlatformManifestServicesError(
        EditorPlatformManifestServicesErrorCode.ProviderManifestNotFound,
        'manifest for context type is not found',
      ).withMessage(contextType);
    }

    return { data: contextManifest.manifest.data ?? {} };
  }
}
